import { inject, Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from '../../components/organisms/snackbars/success-snackbar/success-snackbar.component';
import { ErrorSnackbarComponent } from '../../components/organisms/snackbars/error-snackbar/error-snackbar.component';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private snackbar = inject(MatSnackBar);
  private translocoService = inject(TranslocoService);

  showSuccess(message: string, duration = 30000): void {
    this.translocoService.selectTranslate(message).subscribe((translatedMessage) => {
      const translatedAction = this.translocoService.translate('notification.action');
      const config: MatSnackBarConfig = {
        duration: duration,
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: ['htx-snackbar-success'],
        data: { message: translatedMessage, action: translatedAction }
      };
      this.snackbar.openFromComponent(SuccessSnackbarComponent, config);
    });
  }

  showError(message: string, duration = 30000): void {
    this.translocoService.selectTranslate(message).subscribe((translatedMessage) => {
      const action = this.translocoService.translate('notification.action');
      const config: MatSnackBarConfig = {
        duration: duration,
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: ['htx-snackbar-error'],
        data: { message: translatedMessage, action: action }
      };
      this.snackbar.openFromComponent(ErrorSnackbarComponent, config);
    });
  }
}
